import { ShipmentCreateButton } from "./shipment.create.button";
import { ShipmentCreateForm } from "./shipment.create.form";

export const ShipmentCreate = {
    Button: ShipmentCreateButton,
    Component: ShipmentCreateForm,
}
